<div class="pt-mentoring-task-details__header">
  <pu-icon
    class="pt-mentoring-task-details__completed-icon"
    iconName="pu-checkbox-yes"
    size="24"
    [@completedIcon]="completedIconAnimationState()"
  />

  <h4 class="pt-mentoring-task-details__header-text">
    {{ task()?.title }}
  </h4>

  <button
    class="pt-mentoring-task-details__close"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="cancel()"
  >
    <pu-icon
      iconName="close"
      size="16"
    />
  </button>
</div>

<div class="pt-mentoring-task-details__body">
  @switch (taskConfirmationType()) {
    @case ('manual') {
      @if (task().videoUrl) {
        <iframe
          class="pt-mentoring-task-details__video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          frameborder="0"
          [src]="task().videoUrl | safeUrl"
        >
        </iframe>
      } @else {
        <div class="pt-mentoring-task-details__image">
          <img
            ptImageLoader
            [src]="task().image.url"
            [alt]="task().image.name"
          >
        </div>
      }

      <div
        class="pt-mentoring-task-details__description"
        [froalaView]="task().description"
      ></div>

      @if (task().button) {
        <a
          type="button"
          target="_blank"
          puButton
          size="l"
          uiType="primary"
          [href]="task().button.url"
        >
          {{ task().button.name }}
        </a>
      }

      @if (task().pdfButton) {
        <a
          type="button"
          target="_blank"
          puButton
          size="l"
          uiType="primary"
          [href]="task().pdfButton.pdf.url"
        >
          {{ task().pdfButton.name }}
        </a>
      }

      @if (!isPreviewMode) {
        <mat-slide-toggle
          [formControl]="completedControl"
          [puDisabled]="completedControl.value"
        >
          {{ 'onboardingTask.controls.completed.label' | translate }}
        </mat-slide-toggle>
      }
    }
    @case ('auto') {
      <div class="pt-mentoring-task-details__image">
        @if (taskImgSrc()) {
          <img
            ptImageLoader
            [src]="taskImgSrc()"
            [alt]="(task().entity.mainImage?.name) || (task().image?.name ?? '')"
          >
        }
      </div>

      <div
        class="pt-mentoring-task-details__description"
        [froalaView]="task().description"
      ></div>

      <a
        type="button"
        puButton
        size="l"
        uiType="primary"
        [routerLink]="autoTaskLink()"
        (click)="cancel()"
      >
        {{ taskBtnKey() | translate }}
      </a>
    }
  }
</div>

<pt-confetti/>
